import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { ActiveModelProvider } from "./lib/activeModel";
import { AuthProvider } from "./lib/auth";
import { DisplayPreferencesProvider } from "./lib/displayPreferences";
import "./styles.css";

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Missing #root element");
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <DisplayPreferencesProvider>
          <ActiveModelProvider>
            <App />
          </ActiveModelProvider>
        </DisplayPreferencesProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
